module.exports = __webpack_public_path__ + "img/pic_recharge_right.98390af0.png";